import { constants } from '../../api'

export const ConstantsStoreService = () => {
  return constants()
}
